import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { themeColors } from '../../../../styles/themeColors';

export default makeStyles((theme: Theme) => ({
  title: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: themeColors.iconPrimary,
  },

  description: {
    color: themeColors.textComplimentary,
  },
}));
